import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  legalHintsCardHeader: {
    id: 'legalHintsCardHeader.header',
    defaultMessage: 'Rechtliche Hinweise',
  },
});
